import React, { useEffect, useState } from 'react';
import { useAuth } from '../components/auth/AuthProvider';
import HomePageBase from '../components/HomePageBase';
import PitchPage from './PitchPage';
import ImagePreviews from './ImagePreviews';
import '../assets/styles/HomePageBase.css';
import '../assets/styles/Home.css';

const Home = () => {
  const { user } = useAuth();
  const isLoggedIn = !!user;
  const [recentSession, setRecentSession] = useState(null);

  // Check for any recent sessions that the user might want to continue
  useEffect(() => {
    if (isLoggedIn) {
      // In a real implementation, we'd fetch the most recent session from a backend
      // For now, we'll just simulate it with localStorage
      const storedSession = localStorage.getItem('recentTutorSession');
      if (storedSession) {
        try {
          setRecentSession(JSON.parse(storedSession));
        } catch (e) {
          console.error('Failed to parse stored session', e);
        }
      }
    }
  }, [isLoggedIn]);

  return (
    <div className={`home-page-container ${isLoggedIn ? 'logged-in' : 'not-logged-in'}`}>
      <HomePageBase
        variant={isLoggedIn ? 'auth' : 'public'}
        sessionData={recentSession}
      />

      {!isLoggedIn && (
        <>
          <ImagePreviews variant="public" />
          <div className="pitch-section-wrapper">
            <PitchPage isEmbedded={true} />
          </div>
        </>
      )}
    </div>
  );
};

export default Home;